export const raSubgraphTranslator = {
  // Loan: "ERC721Token",
  loan: "ERC721Token",
  // Loan: "ERC721Token",
  homogenizedLoans: "ERC721Token",
  // ERC721Token: "ERC721Token",
  homogenizer: "ERC20Contract",
};
